import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay } from '@chakra-ui/react';
import { observer } from 'mobx-react';
import ExternalViewerDialogAssetContent from "../hotspot/asset/index";





const ExternalViewerHotspotDialog = (props) => {

const handleOnClose = ()=>{
    props.eviewerStore.clearDialogs()
}


    return (

        <Modal isOpen={props.open} onClose={handleOnClose} motionPreset="slideInBottom" blockScrollOnMount={false} autoFocus={false} size={'6xl'} returnFocusOnClose={false} isCentered scrollBehavior={'inside'}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Asset Details </ModalHeader>
                <ModalCloseButton />
                <ModalBody overflowX={'hidden'} >
                    <ExternalViewerDialogAssetContent spId={props.spId} userId={props.userId}  viewerStore={props.eviewerStore} />
                </ModalBody>
            </ModalContent>
        </Modal>

    )
}

ExternalViewerHotspotDialog.propTypes = {
    open: PropTypes.bool,
    handleClose: PropTypes.any,
    hotspotType: PropTypes.string,
    userId: PropTypes.any,
    eviewerStore: PropTypes.any,
    spId: PropTypes.string
}

export default observer(ExternalViewerHotspotDialog)